
import JsLoader from "If_AdTool/common/JsLoader";
import sdkTool from "If_AdTool/common/sdkTool";
import adControler from "./core/adControler";
import isDom from "If_AdTool/common/IsDom";
import SendUrls from "If_AdTool/common/sendUrl";
import Footer from "./core/footer";
import APPSDK from "./core/appsdk";
import Aptracker from "./core/aptracker";
import adRotatorFactory from "./core/adRotatorFactory";

import adBlock from "./core/adblock";
import adPreload from "./core/adPreload";
import adRegion  from "./core/region";
const pex = "c";
let IfengAmgr = function ()
{
    return {
        pex:pex,
        tplLib:{},
        adElObj:[],
        //增加初始化，统一入口，不在每一个模块自己初始化
        init:function(){
            adBlock.init();
            //adPreview.init();
            adRegion.init();
        },
        start:function(){
            //页面底部处理,目前没什么用
            new Footer({a:1});
        },
        /**
         * 支持预处理
         * **/
        preload:function (...args) {
            adPreload.apply(this,args)
        },
        /**
         * 调用广告总入口
         * */
        show:function(elem,opt,cb=null,errHandler=true,isSendAd=true){
            let el =elem;
            let data = opt;
            if(elem&&!isDom(elem)){
                if(elem.hasOwnProperty&&(elem.hasOwnProperty("aids")||elem.hasOwnProperty("ap"))){
                    el = opt;
                    data = elem;
                }
            }
            //处理设置的dom
            if(isDom(el)){
                if(data.hasOwnProperty("aids")){
                    el.setAttribute(pex,data.aids[0].ap);
                }else{
                    el.setAttribute(pex,data.ap);
                }
                this.adElObj.push(el);
            }
            // 记录广告id，用于库存上
            if(isSendAd){
                if(data.hasOwnProperty("aids")){
                    this.add(data.aids);
                }else{
                    this.add([data]);
                }
            }
            //渲染广告
            if(data.hasOwnProperty("aids")){
                APPSDK.show(data,el,cb,errHandler);
            }
            if(data.hasOwnProperty("rurls")){
                SendUrls(data.rurls)
            }
        },
        //添加广告库存报数
        add:function(arr){
            for(let i=0;i<arr.length;i++){
                let item = arr[i];
                let ap = item.ap+"";
                if (ap.length==8){
                    ap = ap.substr(3);
                }
                Aptracker.add(ap);
            }
        },
        setAdElContent:function(data) {
            //SDK.setElContent(data)
        },
        adControl:adControler,
        adRotatorFactory:adRotatorFactory,
        uuid:sdkTool.creatUuid,
        loadJs:JsLoader,
        showTip:function () {
            for(var i=0;i<this.adElObj.length;i++){
                var el = this.adElObj[i];
                el.style.borderWidth =5+"px";
                el.style.borderColor ="red";
                el.style.position ="relative";
                let elSpan = document.createElement("SPAN");
            }
        }
    }
}();
window.IfengAmgr = IfengAmgr;
window.IfengAmgr.init();